module.exports = __webpack_public_path__ + "img/corrugatedBox1.c66be699.jpg";